// extracted by mini-css-extract-plugin
module.exports = {"line_number":"_2qpRQj0","pointer":"X_BY32O","bigger":"LsDAD5o"};